import { DateTime } from "luxon";

export const DateFormatterPlugin = {
  install(Vue) {
    Vue.prototype.$formatDate = function (date) {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date)
      }
      else if (typeof date === 'string') {
        date = DateTime.fromISO(date);
      }
      else if (date===null || date === undefined){
        date = DateTime.now();
      }
      return date.toFormat("dd.MMM.yyyy").toUpperCase();
    };

    Vue.prototype.$getFromDate = function (date) {
      return DateTime.fromJSDate(date);
    };

    Vue.prototype.$formatTime = function(date_string) {
      var date = new Date(date_string);
      if (date == "Invalid Date") {
        return "Invalid Time";
      }
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? '0'+ minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    };
  },
};
